// library imports
import $ from 'jquery';
import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';

// custom functionality
import testimonialCarousel from './lib/testimonial-carousel';
import fourColCarousel from './lib/four-col-carousel';
import statsCarousel from './lib/stats-carousel';
import listingFilters from './lib/listing-filter';
import loadMorePosts from './lib/load-more-posts';
import fitVids from './lib/fitVids';
import animations from './lib/animations.js';
import sharing from './lib/sharing.js';
import formValidation from './lib/formValidation.js';
import stickyMenu from './lib/stickymenu.js';
import checkLinks from './lib/checkLink';
import teamListing from './lib/team-listing';

window.addEventListener('load', () => {
  // Check if JS is enabled
  animations.initCheckJS();

  // Carousels
  testimonialCarousel.initTestimonialCarousel();
  fourColCarousel.initFourColCarousel();
  statsCarousel.initStatsCarousel();

  // init team listing canvas nav
  teamListing.initCanvasNavigation();

  //Filters
  listingFilters.init('.post-listing-block');

  //Load more {posts}
  loadMorePosts.init('.post-listing-block');

  // Calculate video aspect ratio
  fitVids.initFitVids();

  // Site-wide animations
  animations.initDefaultIntersectionObserver();
  animations.initContentAnimations();

  // Sharing windows
  sharing.initSharing();

  // Form Validation Fix
  formValidation.initValidationFix();

  $('.sub-menu-back-btn').on('click', function () {
    $(this).parents('.menu-item.dropdown').find('> a').dropdown('toggle');
  });

  // Sticky Menu
  stickyMenu.initStickyMenu();

  // Check Links
  checkLinks.init();
});
